
(() => {
  const subscribers = {};

  window.EVENTS = Object.freeze({
    cartUpdate: 'cart:update',       
    cartError: 'cart:error',         
    quantityChange: 'quantity:change',
    drawerOpen: 'drawer:open',       
    drawerClose: 'drawer:close',     
    variantChange: 'variant:change', 
  });

  window.PubSub = {
    subscribe(event, callback) {
      (subscribers[event] = subscribers[event] || []).push(callback);
      return () => {
        subscribers[event] = subscribers[event].filter((cb) => cb !== callback);
      };
    },
    publish(event, data) {
      (subscribers[event] || []).forEach((cb) => {
        try { cb(data); } catch (e) { console.error(`[PubSub:${event}]`, e); }
      });
    },
  };
})();
